/* Light-touch exit intent: only engaged visitors; at most once per seven days. */
(function () {
  'use strict';
  var overlay = document.getElementById('NgExitOverlay');
  if (!overlay) return;
  var dialog = overlay.querySelector('.ng-exit-dialog');
  var closeButton = overlay.querySelector('.ng-exit-close');
  var lastFocus = null;
  var storageKey = 'ngExitConsultationDismissedUntil';
  var sevenDays = 7 * 24 * 60 * 60 * 1000;
  var engagedAt = Date.now();
  var engaged = false;
  var shown = false;
  var isMobile = window.matchMedia('(max-width: 760px), (pointer: coarse)').matches;
  var skip = false;
  try { skip = Number(localStorage.getItem(storageKey) || '0') > Date.now(); } catch (_) { /* private browsing */ }
  var wasPopupSubmission = window.location.search.indexOf('contact_posted=true') !== -1 && window.location.hash.indexOf('NgExitLead') !== -1;
  if (wasPopupSubmission) {
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ng-exit-open');
    var notice = overlay.querySelector('.ng-lead-feedback--success');
    if (notice) notice.focus(); else closeButton.focus();
    overlay.querySelectorAll('[data-ng-exit-close]').forEach(function (el) { el.addEventListener('click', function () {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ng-exit-open');
    }); });
    return;
  }
  if (skip || window.location.search.indexOf('contact_posted=true') !== -1) return;
  function markDismissed() { try { localStorage.setItem(storageKey, String(Date.now() + sevenDays)); } catch (_) {} }
  function open() {
    if (shown || !engaged || Date.now() - engagedAt < 12000 || document.visibilityState !== 'visible') return;
    if (document.querySelector('input:focus, textarea:focus, select:focus')) return;
    shown = true;
    markDismissed();
    lastFocus = document.activeElement;
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ng-exit-open');
    closeButton.focus();
  }
  function close() {
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ng-exit-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('scroll', function () { if (window.scrollY > 180) engaged = true; }, { passive: true });
  document.addEventListener('pointerdown', function () { engaged = true; }, { once: true });
  if (!isMobile) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 8) return;
      open();
    });
  } else {
    /* Mobile has no cursor exit: show only after substantial engagement and delay. */
    var mobileScroll = function () {
      var scrollable = Math.max(1, document.documentElement.scrollHeight - innerHeight);
      if (scrollY / scrollable > 0.55 && engaged) {
        window.removeEventListener('scroll', mobileScroll);
        setTimeout(open, 25000);
      }
    };
    window.addEventListener('scroll', mobileScroll, { passive: true });
  }
  overlay.querySelectorAll('[data-ng-exit-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (overlay.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    if (e.key === 'Tab') {
      var items = Array.prototype.slice.call(dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled])')).filter(function (el) { return el.getClientRects().length; });
      if (!items.length) return;
      if (e.shiftKey && document.activeElement === items[0]) { e.preventDefault(); items[items.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === items[items.length - 1]) { e.preventDefault(); items[0].focus(); }
    }
  });
})();
